import React from 'react'
import Header from './Header'
import { Image, Text, View } from '@react-pdf/renderer'
import QualityBomMeasureSummary from './QualityBomMeasureSummary'
import QualityCheck from './QualityCheck'
import MeasureCheck from './MeasureCheck'
import BOMCheck from './BOMCheck'

const DetailPage = ({ data, order }) => {

    return (
        <>
            <Text
                style={{
                    textAlign: "center",
                    fontSize: "10px",
                }}
            >
                GROUP
            </Text>
            <View style={{
                backgroundColor: "#eeeeee"
            }}>
                <Header data={data} order={order} />
                <QualityBomMeasureSummary data={data} order={order} />

                <QualityCheck data={data} order={order} />
                <MeasureCheck data={data} order={order} />
                <BOMCheck data={data} order={order} />
            </View>
        </>

    )
}

export default DetailPage